// JsFromRoutes CacheKey 68a83dbc5c2d08d0f2e1d42021f68b8a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/posts'),
  new: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/posts/new'),
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/posts/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:org_nano_id/posts/:id'),
}
